import { SyncWithLogo } from '../svg/SyncWithLogo';

interface Props {
  minimal?: boolean;
}

const getSiteSubHeader = () => {
  return (
    <>
      Sync marketing data to{' '}
      <a className="cursor-pointer font-medium hover:text-slate-700" href="/gs">
        Google Sheets
      </a>{' '}
      and{' '}
      <a className="cursor-pointer font-medium hover:text-slate-700" href="/ls">
        Looker Studio
      </a>
    </>
  );
};

export const SiteNav = (props: Props) => {
  const subheader = getSiteSubHeader();

  return (
    <div className="mx-auto items-center">
      <div className="text-slate-700 ">
        <div
          className={`flex flex-row flex-wrap mx-auto md:items-center md:flex-row`}
        >
          <div className="flex flex-row items-center m-0 md:my-3">
            <div>
              <a href="/">
                <SyncWithLogo
                  className="mr-1 fill-current text-indigo-600 mb-1"
                  width={32}
                  height={32}
                />
              </a>
            </div>
            <div className="ml-1">
              <div className="pb-0 m-0 text-xl font-medium text-black cursor-pointer hover:text-slate-500 lg:text-x lg:mr-8">
                <a href="/">SyncWith</a>
              </div>
              {subheader ? (
                <div className="m-0 hidden md:block p-0 text-xs text-gray-500 font-normal">
                  {subheader}
                </div>
              ) : null}
            </div>
          </div>
          {!props.minimal && (
            <div
              className={`flex-1 flex items-center justify-end px-2 lg:ml-6 lg:justify-end my-3 md:my-0`}
            >
              <div></div>
              <div className="ml-2">
                <div className="my-0 md:my-3 inline-block rounded-md sm:mt-0 sm:shrink-0"></div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
